import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './index.css'; // Ensure Tailwind is loaded
import './styles/Pages.css';

// Page components
import Home from './pages/Home';
import About from './pages/About';
import Career from './pages/Career';
import Projects from './pages/Projects';
import TechStack from './pages/TechStack';
import Hobbies from './pages/Hobbies';
import Contact from './pages/Contact';
import ClassicScrollPage from './pages/ClassicScrollPage';

function App() {
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'professional';
    return window.localStorage.getItem('portfolio-theme') || 'professional';
  });

  useEffect(() => {
    window.localStorage.setItem('portfolio-theme', theme);
  }, [theme]);

  return (
    <Router>
      <div className={`App app-theme-${theme}`}>
        {theme === 'ddr' && (
          <header className="ddr-global-header">
            <div className="header-theme-toggle" role="group" aria-label="Theme selector">
              <button
                type="button"
                className={`theme-toggle-btn ${theme === 'professional' ? 'active' : ''}`}
                onClick={() => setTheme('professional')}
              >
                Classic
              </button>
              <button
                type="button"
                className={`theme-toggle-btn ${theme === 'ddr' ? 'active' : ''}`}
                onClick={() => setTheme('ddr')}
              >
                Remix
              </button>
            </div>
            <Link to="/" className="ddr-header-title">
              //Quinton-Tracey
            </Link>
          </header>
        )}
        {theme === 'professional' && (
          <header className="professional-top-header">
            <div className="header-theme-toggle" role="group" aria-label="Theme selector">
              <button
                type="button"
                className={`theme-toggle-btn ${theme === 'professional' ? 'active' : ''}`}
                onClick={() => setTheme('professional')}
              >
                Classic
              </button>
              <button
                type="button"
                className={`theme-toggle-btn ${theme === 'ddr' ? 'active' : ''}`}
                onClick={() => setTheme('ddr')}
              >
                Remix
              </button>
            </div>
            <a href="#about" className="professional-header-name">Quinton Tracey</a>
            <nav className="professional-nav-header">
              <a href="#about" className="professional-nav-link">About</a>
              <a href="#tech-stack" className="professional-nav-link">Tech Stack</a>
              <a href="#career" className="professional-nav-link">Career</a>
              <a href="#projects" className="professional-nav-link">Projects</a>
              <a href="#hobbies" className="professional-nav-link">Hobbies</a>
              <a href="#contact" className="professional-nav-link">Contact</a>
            </nav>
          </header>
        )}
        {theme === 'professional' ? (
          <ClassicScrollPage />
        ) : (
          <Routes>
            <Route path="/" element={<Home theme={theme} />} />
            <Route path="/about" element={<About theme={theme} />} />
            <Route path="/career" element={<Career theme={theme} />} />
            <Route path="/projects" element={<Projects theme={theme} />} />
            <Route path="/tech-stack" element={<TechStack theme={theme} />} />
            <Route path="/hobbies" element={<Hobbies theme={theme} />} />
            <Route path="/contact" element={<Contact theme={theme} />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App; 